import React from 'react';

const AdminCoupon = () => {
  return <div className='content-root'></div>;
};

export default AdminCoupon;
